export default "__VITE_ASSET__CfR9kdtA__"